import { z } from 'zod/v4'

/** `page` starts at 1; `limit` is capped at 100 and defaults to what the subtab asks for. */
export function pageFields(defaultLimit: number) {
  return {
    page: z.coerce.number<number>().int().min(1).default(1),
    limit: z.coerce.number<number>().int().min(1).max(100).default(defaultLimit),
  }
}
